function exibeDetalhe(detalheProduto) {
    const {id, Produto, DescritivoProduto, Objetivo, ConteudoProgramatico, ResultadosEsperados, Beneficios, ContaContabilId, Nome, Sigla, Codigo, CodigoMascara, NomeNivel4, NomeNivel5} = detalheProduto;
    let txt = `<table id="tabeladetalhe">
                <tbody>
                    <tr>
                        <td><strong>Produto:</strong></td>
                        <td>${Produto}</td>
                    </tr>
                    <tr>
                        <td><strong>Descritivo Produto:</strong></td>
                        <td>${DescritivoProduto}</td>
                    </tr>
                    <tr>
                        <td><strong>Objetivo:</strong></td>
                        <td>${Objetivo}</td>
                    </tr>
                    <tr>
                        <td><strong>Conteudo Programático:</strong></td>
                        <td>${ConteudoProgramatico}</td>
                    </tr>
                    <tr>
                        <td><strong>Resultados Esperados:</strong></td>
                        <td>${ResultadosEsperados}</td>
                    </tr>
                    <tr>
                        <td><strong>Benefícios:</strong></td>
                        <td>${Beneficios}</td>
                    </tr>
                    <tr>
                        <td><strong>Conta Contabil Id:</strong></td>
                        <td>${ContaContabilId}</td>
                    </tr>
                    <tr>
                        <td><strong>Nome:</strong></td>
                        <td>${Nome}</td>
                    </tr>
                    <tr>
                        <td><strong>Sigla:</strong></td>
                        <td>${Sigla}</td>
                    </tr>
                    <tr>
                        <td><strong>Código:</strong></td>
                        <td>${Codigo}</td>
                    </tr>
                    <tr>
                        <td><strong>Código Mascara:</strong></td>
                        <td>${CodigoMascara}</td>
                    </tr>
                    <tr>
                        <td><strong>Nome Nível 4:</strong></td>
                        <td>${NomeNivel4}</td>
                    </tr>
                    <tr>
                        <td><strong>Nome Nível 5:</strong></td>
                        <td>${NomeNivel5}</td>
                    </tr>
                </tbody>
            </table>`;
    return txt;
}

function calculaMetaAutomaticamente() {
    let numAtend = document.querySelectorAll(".numeroAtendimento");
    let horasTecnicas = document.querySelectorAll(".horasTecnicas");
    let receita = document.querySelectorAll(".receita");
    let mediaHH = document.getElementById("mediaHH");
    let valorHora = document.getElementById("valorHora");
    
    try{
        Array.from(numAtend).map((num, i) => {
            //horasTecnicas[i].value = num.value * mediaHH.value;
            receita[i].value = horasTecnicas[i].value * valorHora.value;
        });
    } catch(erro) {
    }
}

function calculaMetaMetrologiaAutomaticamente(categoria) {
    let numAtend = document.querySelectorAll(".numeroAtendimento");
    let calibracoes = document.querySelectorAll(".calibracoes");
    let ensaios = document.querySelectorAll(".ensaios");
    let relatoriosELaudos = document.querySelectorAll(".relatoriosELaudos");
    let receita = document.querySelectorAll(".receita");
    let mediaHH = document.getElementById("mediaHH");
    let valorHora = document.getElementById("valorHora");

    try{
        Array.from(relatoriosELaudos).map((num, i) => {
            receita[i].value = relatoriosELaudos[i].value * valorHora.value;
        });
        /*
        if(categoria === "Ensaios") {
            Array.from(relatoriosELaudos).map((num, i) => {
                receita[i].value = ensaios[i].value * valorHora.value;
            });
        }
        else {
            Array.from(relatoriosELaudos).map((num, i) => {
                receita[i].value = calibracoes[i].value * valorHora.value;
            });
        }
        */
    } catch(erro) {
    }
    
}

function limpar() {
    limparTodosOsCamposDoFormulario();
    try {

        let categoria = document.getElementById("categoria").value;
        let calibracoes = document.querySelectorAll(".calibracoes");
        let ensaios = document.querySelectorAll(".ensaios");

        if(categoria === "Ensaios") {
            Array.from(ensaios).forEach(el => el.removeAttribute("disabled"));
            Array.from(calibracoes).forEach(el => el.setAttribute("disabled", true));
        }
        else if(categoria === "Calibração") {
            Array.from(ensaios).forEach(el => el.setAttribute("disabled", true));
            Array.from(calibracoes).forEach(el => el.removeAttribute("disabled"));
        }
        
    } catch(erro) {
    }
}

function limparTodosOsCamposDoFormulario() {

    let metaEmpresasAtendidas   = document.getElementById("metaEmpresasAtendidas");
    let metaAtendimentos        = document.getElementById("metaAtendimentos");
    let mediaHH                 = document.getElementById("mediaHH");
    let totalHH                 = document.getElementById("totalHH");
    let totalEnsaiosCalibracoes = document.getElementById("totalEnsaiosCalibracoes");
    let totalLaudosRelatorios   = document.getElementById("totalLaudosRelatorios");
    let valorHora               = document.getElementById("valorHora");
    let receitaPrevista         = document.getElementById("receitaPrevista");

    let horasTecnicas           = document.querySelectorAll(".horasTecnicas");
    let numeroAtendimento       = document.querySelectorAll(".numeroAtendimento");
    let calibracoes             = document.querySelectorAll(".calibracoes");
    let ensaios                 = document.querySelectorAll(".ensaios");
    let relatoriosELaudos       = document.querySelectorAll(".relatoriosELaudos");
    let receita                 = document.querySelectorAll(".receita");
    let despesa                 = document.querySelectorAll(".despesa");

    metaEmpresasAtendidas.value = ''
    metaAtendimentos.value = '' 
    mediaHH.value = ''
    totalHH.value = '' 
    totalEnsaiosCalibracoes.value = ''
    totalLaudosRelatorios.value = ''
    valorHora.value = ''
    receitaPrevista.value = ''

    let nome = [horasTecnicas, numeroAtendimento, calibracoes, ensaios, relatoriosELaudos, receita, despesa];

    nome.forEach(atributo => {
        Array.from(atributo).forEach(el => el.value = '');
    });

}

function verificaCadastro(categoria, valores) {
    let { totalCalibracoes, totalEnsaios, totalRelatoriosELaudos, totalNumeroAtendimento, totalHorasTecnicas } = valores;
    let isVerificado = false;

    let metaAtendimentos = document.getElementById("metaAtendimentos").value;
    let totalEnsaiosCalibracoes = document.getElementById("totalEnsaiosCalibracoes").value;
    let totalLaudosRelatorios = document.getElementById("totalLaudosRelatorios").value;
    let totalHH = document.getElementById("totalHH").value;

    switch(categoria) {
        case "Ensaios":
            if(totalEnsaios === Number(totalEnsaiosCalibracoes) && totalRelatoriosELaudos === Number(totalLaudosRelatorios) && totalNumeroAtendimento === Number(metaAtendimentos)) isVerificado = true;
            break;
        case "Calibração":
            if(totalCalibracoes === Number(totalEnsaiosCalibracoes) && totalRelatoriosELaudos === Number(totalLaudosRelatorios) && totalNumeroAtendimento === Number(metaAtendimentos)) isVerificado = true;
            break;
        default:
            if(totalNumeroAtendimento === Number(metaAtendimentos) && Number(totalHorasTecnicas.toFixed(2)) === Number(totalHH)) isVerificado = true
    }
    
    return isVerificado;
}

function informaSomaTotalAtual() {

    let horasTecnicas                     = document.querySelectorAll(".horasTecnicas");
    let numeroAtendimento                 = document.querySelectorAll(".numeroAtendimento");
    let calibracoes                       = document.querySelectorAll(".calibracoes");
    let ensaios                           = document.querySelectorAll(".ensaios");
    let relatoriosELaudos                 = document.querySelectorAll(".relatoriosELaudos");
    let receita                           = document.querySelectorAll(".receita");
    let despesa                           = document.querySelectorAll(".despesa");

    let horasTecnicasValorTotal           = document.getElementById("horasTecnicasValorTotal");
    let numeroAtendimentoValorTotal       = document.getElementById("numeroAtendimentoValorTotal");
    let calibracoesValorTotal             = document.getElementById("calibracoesValorTotal");
    let ensaiosValorTotal                 = document.getElementById("ensaiosValorTotal");
    let relatoriosELaudosValorTotal       = document.getElementById("relatoriosELaudosValorTotal");
    let receitaValorTotal                 = document.getElementById("receitaValorTotal");
    let despesaValorTotal                 = document.getElementById("despesaValorTotal");

    let indicadores = [ horasTecnicas, numeroAtendimento, calibracoes, ensaios, relatoriosELaudos, receita, despesa ]
    let indicadoresTotal = [ horasTecnicasValorTotal, numeroAtendimentoValorTotal, calibracoesValorTotal, ensaiosValorTotal, relatoriosELaudosValorTotal, receitaValorTotal, despesaValorTotal ]
    
    indicadores.forEach((indicador, indice) => {
        
        try {
            let total = Array.from(indicador).reduce((acc, atual) => acc + Number(atual.value), 0);
            indicadoresTotal[indice].innerHTML = formataValor(total, indicadoresTotal[indice])
            indicadoresTotal[indice].style.color = formataCor(indicadoresTotal[indice], total)
        } catch(erro) {
        }

    });

}

function formataCor(indice, total) {

    let totalHH                 = Number(document.getElementById("totalHH").value).toLocaleString("pt-br", { maximumFractionDigits: 2 });
    let metaAtendimentos        = Number(document.getElementById("metaAtendimentos").value).toLocaleString("pt-br", { maximumFractionDigits: 2 });
    let totalEnsaiosCalibracoes = Number(document.getElementById("totalEnsaiosCalibracoes").value).toLocaleString("pt-br", { maximumFractionDigits: 2 });
    let totalLaudosRelatorios   = Number(document.getElementById("totalLaudosRelatorios").value).toLocaleString("pt-br", { maximumFractionDigits: 2 });
    let receitaPrevista         = Number(document.getElementById("receitaPrevista").value).toLocaleString("pt-br", { maximumFractionDigits: 2 });

    let cor = "red";

    total = Number(total).toLocaleString("pt-br", { maximumFractionDigits: 2 });;

    switch(indice.getAttribute("id")) {
        case "numeroAtendimentoValorTotal":
            if(metaAtendimentos == total) cor = "green";
            break;
        case "horasTecnicasValorTotal":
            if(totalHH == total) cor = "green";
            break;
        case "calibracoesValorTotal":
            //if(Number(totalEnsaiosCalibracoes.value || totalLaudosRelatorios.value) === total) cor = "green";
            if(totalEnsaiosCalibracoes == total) cor = "green";
            break;
        case "ensaiosValorTotal":
            if(totalEnsaiosCalibracoes == total) cor = "green";
            break;
        case "relatoriosELaudosValorTotal":
            if(totalLaudosRelatorios == total) cor = "green";
            break;
        case "receitaValorTotal":
            if(receitaPrevista == total) cor = "green";
            break;
        case "despesaValorTotal":
            cor = "#212529";
            break;
    }

    return cor;
}

function formataValor(valor, indicador) {
    if(valor !== null && valor !== undefined) {
        if(["receitaValorTotal", "despesaValorTotal"].indexOf(indicador.getAttribute("id"))) {
            valor = valor.toLocaleString("pt-BR", { maximumFractionDigits: 2 , style: 'decimal' });
        }
        else {
            valor = valor.toLocaleString("pt-BR", { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' })
        }
    } 
    else {
        valor = "-"
    }
    return valor;
}

function limpaSoma() {

    try {

        let numeroAtendimentoValorTotal = document.getElementById("numeroAtendimentoValorTotal");
        let horasTecnicasValorTotal     = document.getElementById("horasTecnicasValorTotal");
        let calibracoesValorTotal       = document.getElementById("calibracoesValorTotal");
        let ensaiosValorTotal           = document.getElementById("horasTecnicasValorTotal");
        let receitaValorTotal           = document.getElementById("receitaValorTotal");
        let despesaValorTotal           = document.getElementById("despesaValorTotal");
        
        numeroAtendimentoValorTotal.innerHTML = ''
        horasTecnicasValorTotal.innerHTML = ''
        receitaValorTotal.innerHTML = ''
        despesaValorTotal.innerHTML = ''
        calibracoesValorTotal.innerHTML = ''
        ensaiosValorTotal.innerHTML = ''
        
    } catch(erro) {

    }
}


export default { exibeDetalhe, calculaMetaAutomaticamente, calculaMetaMetrologiaAutomaticamente, limpar, verificaCadastro, informaSomaTotalAtual, limpaSoma }